import {CookingItem} from "./CookingItem";
import {Callback} from "../../Core/Reflection";
import {Ease} from "../../Core/Animatable";
import {Particles} from "../../Core/Particles";
import {textureOrDefault} from "../../Core/AssetHelpers";

export class Ingredient extends CookingItem {

    readonly pouringPoint = {x: 0, y: 0};
    readonly pouringColor: string;
    readonly pouringScale: number;
    pouringLifetime?: number;

    constructor(pouringColor = "#ffffff", pouringScale = 0.5) {
        super();
        this.pouringColor = pouringColor;
        this.pouringScale = pouringScale;
    }

    pour(cb?: Callback) {
        const pouring = this.visuals.addChild(this.getPouring());
        pouring.x = this.pouringPoint.x;
        pouring.y = this.pouringPoint.y;
        pouring.rotation = -this.rotation;
        if (this.pouringLifetime !== undefined) {
            pouring.emitter.emitterLifetime *= this.pouringLifetime;
            pouring.emitter.frequency /= this.pouringLifetime;
        }
        pouring.emitter.playOnce(() => {
            this.tweenTo<Ingredient>(0.4, Ease.sineInOut, {
                rotation: 0,
                y: this.y - this.height * 0.5,
                onComplete: () => this.alphaTo(0, 0.2, cb)
            });
        });
        return pouring;
    }

    protected getPouring() {
        return new Pouring(this.pouringColor, this.pouringScale);
    }
}

export class Pouring extends Particles {

    constructor(color = "#ffffff", scale = 0.5) {
        super(textureOrDefault("particle-circle"), {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": scale,
                "end": scale,
                "minimumScaleMultiplier": 0.5
            },
            "color": {
                "start": color,
                "end": color
            },
            "speed": {
                "start": 100,
                "end": 0,
                "minimumSpeedMultiplier": 0.7
            },
            "acceleration": {
                "x": 0,
                "y": 400
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 0,
                "max": 0
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 0.2,
                "max": 0.8
            },
            "blendMode": "normal",
            "frequency": 0.001,
            "emitterLifetime": 0.4,
            "maxParticles": 400,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": false,
            "spawnType": "point"
        });
        this.emitter.autoUpdate = true;
        this.scale.set(2);
    }
}